import { render, staticRenderFns } from "./WillStaff.vue?vue&type=template&id=8019db48&scoped=true&"
import script from "./WillStaff.vue?vue&type=script&lang=js&"
export * from "./WillStaff.vue?vue&type=script&lang=js&"
import style0 from "./WillStaff.vue?vue&type=style&index=0&id=8019db48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8019db48",
  null
  
)

export default component.exports